module.exports = __webpack_public_path__ + "img/Risk_Rate_v2_24@2x.395bf002.png";